module.exports = __webpack_public_path__ + "img/02.cd899c7b.png";